module.exports = __webpack_public_path__ + "img/volume-x.43116695.svg";